import axios from "axios";
import { ORDER_PROXY_API } from "constants/apiUrls";



// 상점 매핑 조회
export const shopMapping = async (shopId) => {
  let posShopId = await axios.get(
    `${ORDER_PROXY_API}/shop/v2/pos/shop-code?channelType=2&shopId=${shopId}`
  );

  return posShopId.data.shopId;
}

// 메뉴 그룹 매핑 조회
export const menuGrpMapping = async (menuGrpId) => {
  let posMenuGrpId = await axios.get(
    `${ORDER_PROXY_API}/product/v2/pos/group/code?channelType=2&productGroupId=${menuGrpId}`
  );

  return posMenuGrpId.data.productGroupId;
}

// 메뉴 매핑 조회
export const menuMapping = async (menuId) => {
  let posMenuId = await axios.get(
    `${ORDER_PROXY_API}/product/v2/pos/product-code?channelType=2&productId=${menuId}`
  );

  return posMenuId.data.productId;
}

// 메뉴 매핑
export const addMenuMapping = async (orderId, posId) => {
  await axios.post(`${ORDER_PROXY_API}/product/v2/mapping/code`, {
    channelType: 2,
    data: [{
      posProductId: Number(posId),
      orderProductId: String(orderId)
    }]
  })
}

// 옵션 그룹 매핑 조회
export const optionGrpMapping = async (optionGrpId) => {
  let postOptionGrpId = await axios.get(
    `${ORDER_PROXY_API}/product/v2/pos/option-group/code?channelType=2&productOptionGroupId=${optionGrpId}`
  )

  return postOptionGrpId.data.productOptionGroupId;
}

// 옵션 매핑 조회
export const optionMapping = async (optionId) => {
  let posOptionId = await axios.get(
    `${ORDER_PROXY_API}/product/v2/pos/option-code?channelType=2&productOptionId=${optionId}`
  );

  return posOptionId.data.productOptionId;
}